import React, { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { WizardSteps } from "./WizardSteps";
import { Nextsteps } from "./NextStep";
import { DndProvider } from "react-dnd";
import Backend from "react-dnd-html5-backend";
import warning from "../../assets/icons/warning.png";
import DraggableComponent from "./../../components/DraggableComponent";
import ProfilePic from "./profilePic";

export const Fourth = (props) => {
  const validate = () => {
    if (window.confirm("Are you sure you want to go back?")) {
      // eslint-disable-line
      props.previousStep();
    }
  };

  const [state, setState] = useState({
    profilePhotoSelected: true,
    proilePhotoUrl: "",
  });

  const updateImageUrl = (url) => {
    setState({
      ...state,
      proilePhotoUrl: url,
    });
  };

  // step4: {
  //   profilePhotoSelected: true,
  //   proilePhotoUrl: "aaaaaaaaaaaaa",
  // },

  useEffect(() => {
    let { proilePhotoUrl } = state;
    let TutorInfoObj = props?.TutorInfoObj ? props?.TutorInfoObj : {};
    proilePhotoUrl = TutorInfoObj?.step4?.proilePhotoUrl;
    setState((state) => ({
      ...state,
      proilePhotoUrl,
    }));
    if (props.funcStatus === "loading..." && props.currentStep === 4) {
      submitStep4Info(true);
    }
  }, [props]);

  const submitStep4Info = (isCallApi) => {
    const { profilePhotoSelected, proilePhotoUrl } = state;
    const { TutorInfoObj } = props;

    let step4 = {
      profilePhotoSelected,
      proilePhotoUrl,
    };
    TutorInfoObj.step4 = step4;
    props.AddTutorInfo(TutorInfoObj);
    return isCallApi ? props.AddTutorInfoStepBeforeCallApi("done") : null;
    // if (proilePhotoUrl) {
    //   TutorInfoObj.step4 = step4;
    //   props.AddTutorInfo(TutorInfoObj);
    //   return true;
    // } else {
    //   return false;
    // }
  };

  const checkImagedimension = (imageValidated, imgEl) => {
    console.log(imageValidated, "====nbbnmb=");
    const { proilePhotoUrl } = state;
    if (imageValidated) {
      setState({
        ...state,
        confirmShow: false,
      });
    } else {
      setState({
        proilePhotoUrl: "",
        confirmShow: true,
        ImgHeight: imgEl?.current?.naturalHeight,
        ImgWidth: imgEl?.current?.naturalWidth,
      });
    }
  };

  const { proilePhotoUrl, ImgHeight, ImgWidth, confirmShow } = state;
  const { iscompletedForm, validationError } = props;

  let warningError = (
    <img
      src={warning}
      alt="warning"
      width="14px"
      height="14px"
      style={{ marginRight: "6px" }}
    />
  );

  return (
    <Row className="m-0">
      <WizardSteps step={4} {...props} previousStep={validate} />
      <Col lg={12} md={12} sm={12} xs={12}>
        <div className="container">
          <Row>
            <Col
              lg={12}
              md={12}
              sm={12}
              xs={12}
              className="profile subject-mode"
            >
              <h1 className="step-title">
                Add profile picture to your tutoring service
              </h1>
              <h2 className="step-subtitle">
                This is the photo that will appear on your profile when parents
                and students browse for tutors.
              </h2>
              <Row>
                <Col lg={4} md={6} sm={12} xs={12}>
                  <DndProvider backend={Backend}>
                    <DraggableComponent
                      TargetChildComponent={ProfilePic}
                      updateImageUrl={updateImageUrl}
                      imageUrl={proilePhotoUrl}
                      typeNo={"0"}
                      iscompletedForm={iscompletedForm}
                      checkImagedimension={checkImagedimension}
                      confirmonHide={() =>
                        setState({
                          ...state,
                          confirmShow: false,
                        })
                      }
                      ImgHeight={ImgHeight}
                      ImgWidth={ImgWidth}
                      confirmShow={confirmShow}
                      validationError={validationError}
                    />
                  </DndProvider>
                </Col>
              </Row>
              <div className="error" style={{ marginTop: "5px" }}>
                {!proilePhotoUrl
                  ? validationError?.data
                    ? warningError
                    : ""
                  : ""}
                {!proilePhotoUrl
                  ? validationError?.data
                    ? "Add profile picture to your tutoring service"
                    : ""
                  : ""}
              </div>
            </Col>
          </Row>
          <Nextsteps step={4} {...props} submitStepInRedux={submitStep4Info} />
        </div>
      </Col>
    </Row>
  );
};
